module.exports = __webpack_public_path__ + "img/partner-5.9a886f79.png";